module.exports = __webpack_public_path__ + "img/9.9681aa1c.jpg";